import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import { required } from "utils/validation.util";
import TextField from "app/components/form/TextField";
import { MARKER_FORM } from "features/planner/planner.constants";

import classNames from "classnames";
import { green } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

import { getFileBase64 } from "utils/app.util";
import ModalTab from "app/components/Modal/ModalTab";
import { validateMarkerForm } from "utils/validation.util";
import FileUploadField from "app/components/form/FileUploadField/FileUploadField";
import ModalTabsMarker from "features/planner/settings/markers/components/ModalTabsMarker";

const MarkerForm = ({ handleSubmit, classes, change }) => {
  return (
    <form onSubmit={handleSubmit} id={MARKER_FORM.ID}>
      <Grid container direction="column">
        <Grid item container spacing={2}>
          <Field
            name={MARKER_FORM.FILE}
            component={FileUploadField}
            DropzoneProps={{
              multiple: false,
              accept: "image/*",
            }}
            required
            validate={[validateMarkerForm]}
            onChange={files => {
              getFileBase64(files.first()).then(fileBase64 =>
                change(MARKER_FORM.ICON, fileBase64),
              );
            }}
          >
            {({ getRootProps, openFileDialog, isDragActive }) => {
              return (
                <Grid {...getRootProps()} className={classes.fileInputRoot}>
                  <ModalTab
                    disabled
                    TabProps={{
                      classes: {
                        item: classNames(classes.tabItem, {
                          [classes.tabItemIsDragActive]: isDragActive,
                        }),
                      },
                      component: Grid,
                    }}
                  >
                    <ModalTabsMarker openFileDialog={openFileDialog} />
                  </ModalTab>
                </Grid>
              );
            }}
          </Field>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              autoFocus
              label="Name"
              component={TextField}
              required
              validate={[required]}
              name={MARKER_FORM.NAME}
            ></Field>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

const styles = {
  tabItem: {
    minWidth: 150,
    display: "flex",
    alignItems: "center",
    background: "white",
    "&:hover": {
      background: "white",
    },
  },
  fileInputRoot: {
    outline: "none",
    display: "flex",
  },
  tabItemIsDragActive: {
    background: green[100],
  },
};

export default compose(withStyles(styles), React.memo)(MarkerForm);
